import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import UserContext from "../../Contexts/UserContext";
import { useForm } from "react-hook-form";
import { AuthService } from "../../Services";
import "./Login.css";
import { toast } from "react-toastify";
import { DateHelpers } from "../../Helpers/Date/DateHelpers";
import {
  toastSuccessMessage,
  InputControl,
  InputValidationConstants,
  Loading,
  LogotypeBelkaPoziom,
} from "wup-module1-base";

function Login() {
  const loginSuccessMessage = "Zalogowano";
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const lastPath = sessionStorage.getItem("lastExclusiveOfferPath");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "all",
  });

  const login = (data) => {
    setIsSubmitting(true);
    AuthService.login(data)
      .then((response) => {
        localStorage.setItem("isUser", "true");
        setUser({
          id: response.data.id,
          firstName: response.data.name,
          lastName: response.data.sureName,
          currentStep: response.data.status,
          isFirstRecrutation: DateHelpers.checkIsFirstRecruitmentMember(
            response.data.recruitingStageNumber
          ),
          permissions: [],
          roles: [],
          contractRecruitmentTypes: response.data.contractRecruitmentTypes,
          registerDate: response.data.registerDate,
          clientStep: response.data.clientStep,
          recruitmentType: response.data.recruitmentType,
          fromReserveList: response.data.fromReserveList,
          consentToVouchers: response.data.consentToVouchers,
        });
        toastSuccessMessage(loginSuccessMessage);
        if (!!lastPath) {
          navigate(lastPath);
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        !!error.response.data.message ? toast.error(error.response.data.message, {
          autoClose: false
        }) : toast.error(
          "Niepoprawne dane logowania lub konto zostało zablokowane!"
        );
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <Form onSubmit={handleSubmit(login)}>
      <Row className="row-header-logo">
        <Col md={3} className="login-header-col">
          <div className="login-header-text">
            <h1 className="login-header d-inline-block align-self-end mb-1">
              Logowanie
            </h1>
          </div>
        </Col>
        <Col md={9} className="login-image-col">
          <img
            className="d-inline-block image-fluid login-image"
            src={LogotypeBelkaPoziom}
            alt="Logo MAŁOPOLSKI"
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6}>
          <InputControl
            id="login"
            label="Login"
            refs={{
              ...register("login", {
                required: InputValidationConstants.required,
              }),
            }}
            errors={errors}
          />
        </Col>
        <Col md={6}>
          <InputControl
            id="password"
            label="Hasło"
            type="password"
            refs={{
              ...register("password", {
                required: InputValidationConstants.required,
              }),
            }}
            errors={errors}
          />
        </Col>
      </Row>
      <Row className="my-0">
        <Col className="text-right">
        <Button className="simple-btn" onClick={() => navigate("/forgotPassword")}>
          <a
            className="mr-3 text-dark tex t-underline cursor-pointer"
          >
            Nie pamiętam hasła
          </a>

        </Button>
          <Button
            type="submit"
            variant="login-submit"
            disabled={isSubmitting}
            className="px-5"
          >
            {isSubmitting ? (
              <Loading size="sm" className="p-0" variant="light" />
            ) : (
              "Zaloguj"
            )}
          </Button>
        </Col>
      </Row>
    </Form>
  );
}

export default Login;
